// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import { createApiClient } from "./config/axios-config.js";
import { LoginConfig } from "./config/login-config.js";

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default class AuthRequiredService {

  #apiClient = createApiClient();

  constructor() {
    // Set token in `Authorization` header in each request
    this.#apiClient.interceptors.request.use(config => {
      const token = window.localStorage.getItem("accessToken");
      config.headers.Authorization = token ? `Bearer ${token}` : "";

      return config;
    });
    this.#apiClient.interceptors.response.use(response => response, error => {
      if ([401, 403].includes(error.response.status)) {
        window.location.href = LoginConfig.indexPageURL.replace("/index", "/login");
      }
      return error;
    });
  }

  useApiClient() {
    return this.#apiClient;
  }
}